import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorTransactionOrderLinesSearch = () => {
  const transactionOrderLinesSearch = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/transaction/order-lines/search', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
    })
  }, [])

  return { transactionOrderLinesSearch }
}

export default InteractorTransactionOrderLinesSearch
